import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';

import TodoListDialog from './Dialog';
import TodoItem from './TodoItem';

import { Button, Typography, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { fetchTodos } from '../../api/objective/todo.api';
import { useQuery } from 'react-query';
import { addAlert } from '../../actions/alerts.action';

const TodosPanel = ({ objectiveId, status }) => {
  const dispatch = useDispatch();

  const [ todoListDialogOpen, setTodoListDialogOpen ] = useState(false);

  const todosQuery = useQuery(
    [ 'todos', objectiveId ],
    async () => {
      const { data } = await fetchTodos({ objectiveId });
      data.sort((x, y) => new Date(x.deadline) - new Date(y.deadline));
      return data;
    },
    {
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );
  const todos = todosQuery.data ?? [];

  const { t } = useTranslation();

  const useStyles = makeStyles({
    title: {
      color: '#999999',
      fontSize: '16px',
      textTransform: 'uppercase'
    },
    btn: {
      marginTop: '20px'
    },
    container: {
      backgroundColor: '#F4F4F4',
      padding: '20px'
    },
    noTodo: {
      marginTop: '5px'
    }
  });

  const classes = useStyles();

  return (
    <Container className={ classes.container }>
      <Typography className={ classes.title }>
        { t('objective.todos.list.title') }
      </Typography>
      { todos.length !== 0 ? todos.map(todo => (
        <TodoItem
          key={ todo.id }
          todo={ todo }
          objectiveId={ objectiveId }
          onSubmitSuccess={ todosQuery.refetch }
          status={ status }
        />
      )) :
        <Typography variant="body2"  className={ classes.noTodo }>
          { t('objective.todos.noTodo') }
        </Typography>
      }
      <Button
        className={ classes.btn }
        variant='contained'
        color="secondary"
        onClick={ () => setTodoListDialogOpen(true) }
      >
        { todos.length === 0 ?
          t('objective.todos.list.create.btn')  :
          t('objective.todos.list.edit.btn')
        }
      </Button>
      <TodoListDialog
        open={ todoListDialogOpen }
        handleClose={ () => setTodoListDialogOpen(false) }
        objectiveId={ objectiveId }
        todos={ todos }
        onSubmitSuccess={ todosQuery.refetch }
        status={ status }
      />
    </Container>
  );
};

export default TodosPanel;
